import { api } from '@utils'

import { GetAllEventResponse, GetAllEventParams, EventService } from '.'

const getAllEvent = async (
	params: GetAllEventParams
): Promise<GetAllEventResponse> => {
	try {
		const res = await api.get<GetAllEventResponse>('/event-public', { params })
		return res.data
	} catch (e) {
		throw e
	}
}

export const eventService: EventService = {
	getAllEvent
}
